import { useQuery } from '@tanstack/react-query';

export function useTopology() {
  return useQuery({
    queryKey: ['map', 'topology'],
    queryFn: async () => {
      const res = await fetch('/api/map/communities');
      if (!res.ok) throw new Error('Failed to fetch map topology');
      return res.json();
    },
    staleTime: Infinity, // TopoJSON is static, never refetch
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}
